module.exports = __webpack_public_path__ + "static/img/pin.6964f4d0.svg";